const LPB_MENU_SELECTORS = [
    '.mega-menu__link',
    '.menu-drawer__menu-item',
    '.list-menu.list-menu--inline > li > a',
    '.menu-drawer__menu > li > a',
    '.header__menu-item'
];

const LPB_MENU_HEX = /^#?([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

function normalizeMenuColor(raw) {
    if (!raw) return null;
    const value = raw.trim();
    if (!value) return null;
    // "##FFCE2E" laisse "FFCE2E" apres le split : on remet le #
    if (LPB_MENU_HEX.test(value)) return value.startsWith('#') ? value : `#${value}`;
    return value;
}

function ensureMenuTitleSpan(elem) {
    const existing = elem.querySelector('span');
    if (existing) return existing;

    const span = document.createElement('span');
    Array.from(elem.childNodes).forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
    });
    elem.insertBefore(span, elem.firstChild);
    return span;
}

function updateMenuItem(elem) {
    if (elem.dataset.lpbMenuParsed === 'true') return;

    const textContent = elem.textContent.trim();
    let title = textContent, imgSrc, color;

    if (textContent.includes('##')) {
        const parts = textContent.split('##');
        title = parts[0].trim();
        color = normalizeMenuColor(parts[1]);
    }

    if (!color && !title.includes('|') && !title.includes('&&')) return;

    if (title.includes('|')) {
        [title, imgSrc] = title.split('|').map(part => part.trim());

        const imgElement = document.createElement('img');
        imgElement.src = imgSrc;
        imgElement.alt = '';
        imgElement.style.maxWidth = '100%';
        imgElement.style.height = 'auto';

        const titleSpan = document.createElement('span');
        titleSpan.classList.add('button', 'button--white', 'button--nohover', 'button--s');
        titleSpan.textContent = title;
        if (color) titleSpan.style.color = color;

        const container = document.createElement('div');
        container.classList.add('lpb-menu-image');
        container.appendChild(imgElement);
        container.appendChild(titleSpan);

        elem.innerHTML = '';
        elem.appendChild(container);
        const parentLi = elem.closest('li');
        if (parentLi) parentLi.classList.add('lpb-menu-custom-li');
    } else if (title.includes('&&')) {
        [title] = title.split('&&').map(part => part.trim());
        const spanElement = ensureMenuTitleSpan(elem);
        spanElement.classList.add('lpb-menu-title', 'lpb-body-m-bold');
        spanElement.textContent = title;
        if (color) spanElement.style.color = color;
    } else {
        const spanElement = ensureMenuTitleSpan(elem);
        spanElement.textContent = title;
        spanElement.style.color = color;
    }

    elem.dataset.lpbMenuParsed = 'true';
}

function updateMenuItems(root) {
    const scope = root || document;
    LPB_MENU_SELECTORS.forEach(selector => {
        scope.querySelectorAll(selector).forEach(updateMenuItem);
    });
}

updateMenuItems();
document.addEventListener('shopify:section:load', event => updateMenuItems(event.target));
